import styled from 'styled-components';
import { makeHelperLine, makeHelperText, makeErrorMessage } from '../field/mixins';
export const HelperLine = styled.div `
  ${() => makeHelperLine()}
`;
export const HelperText = styled.span `
  ${() => makeHelperText()}
`;
export const ErrorMessage = styled.span `
  ${(prop) => makeErrorMessage(prop)}
`;
